export default "__VITE_ASSET__a3405423__"